import type { Schemas } from "@softmax/observatory-client/types";

type Viewer = Schemas["WhoAmIResponse"];

export function viewerIdentity(viewer: Viewer): string {
  return JSON.stringify([
    viewer.subject_type,
    viewer.subject_id,
    viewer.owner_user_id,
    viewer.user_email,
    viewer.is_softmax_team_member,
    viewer.is_softmax_admin,
    (viewer.scopes ?? []).toSorted(),
  ]);
}

export function identityChanged({
  previous,
  current,
}: {
  readonly previous: string | null | undefined;
  readonly current: string | null | undefined;
}): boolean {
  return (
    previous !== undefined && current !== undefined && previous !== current
  );
}
